import { render, staticRenderFns } from "./MLaporanPJB.vue?vue&type=template&id=195b645c&scoped=true&lang=html&"
import script from "./MLaporanPJB.vue?vue&type=script&lang=js&"
export * from "./MLaporanPJB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b645c",
  null
  
)

export default component.exports